import * as React from 'react';
import * as SalesStore from '../SalesStore';
import * as Images from 'pos/Images';

import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { OnlineReservationInListDTO, Res, Permission } from 'core/api';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';

import { ReservationDetails } from './ReservationDetails';
import { OnlineReservationFacade } from 'pos/facades';
import { Modal } from 'core/ui-next/modal';

type Props = { currentReservation: OnlineReservationInListDTO } & Modal.Actions<void>;
type State = { reservation: Nullable<OnlineReservationInListDTO> };

class ReservationScreen extends PosScreenClassComponent<Props, State> {

	protected useKeypad() {
		return false;
	}

	protected getScreenId(): string {
		return 'SHOW_CURRENT_RESERVATION';
	}

	protected getTitle(): string {
		return Res.Web.ONLINE_RESERVATION_DETAILS();
	}

	protected getImage(): string | SvgIcon {
		return Images.OnlineReservation;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {

		const onRemoveReservation = async () => {

			if (SalesStore.getTicket().HasOnlineReservation)
				this.setState({ reservation: null }, async () => await SalesStore.removeReservation());
		};

		const onChangeReservation = async () => {
			const result = await Command.execute('selectReservation');
			if (result.ok) {
				if (SalesStore.getTicket().HasOnlineReservation)
					await SalesStore.removeReservation();

				this.setState({ reservation: result.value }, async () => await SalesStore.setReservation(result.value));
			}
		};

		return [
			this.cancelButton(),
			null,
			null,
			null,
			{ title: Res.Web.MANAGE_ONLINE_RESERVATION_SEARCH_REMOVE(), image: Images.RemoveReservation, action: onRemoveReservation },
			{ title: Res.Web.MANAGE_ONLINE_RESERVATION_SEARCH_RESERVATIONS(), image: Images.ChangeReservation, action: onChangeReservation }
		];
	}

	protected getContent(): React.ReactNode {
		return <ReservationDetails reservation={this.state.reservation} showLocation={false} />;
	}

	createInitialState(props: Props): Nullable<State> {
		return { reservation: props.currentReservation };
	}

	onComponentDidMount(): void {
		this.on('pos:sale:operation-failed', async () => this.cancel());
	}

	onComponentWillUnmount(): void {
	}

}

declare global {
	interface CommandType {
		showCurrentReservation: () => Promise<Result>
	}
}

Command.register('showCurrentReservation', Preconditions.and(Preconditions.ensure(Permission.OnlineReservation_Attend), Preconditions.ensureIsNotLite), async (): Promise<Result<void>> => {
	const reservation = await OnlineReservationFacade.getDetails(SalesStore.getTicket());
	return Modal.show(ReservationScreen, { currentReservation: reservation });
});
